/* tslint:disable:max-classes-per-file */
import {
  IsBoolean,
  IsDefined,
  IsNotEmpty,
  IsNumber,
  IsOptional,
  IsString,
  ValidateNested,
} from 'class-validator';
import { Transform, Type } from 'class-transformer';
import { EcomProductCustomOption } from './ecom';
import { EcomCampaign } from './campaign';

export class EcomProductCombinationMedia {
  @IsDefined()
  @IsString()
  image!: string;

  @IsOptional()
  @IsString()
  imageType?: string;

  @IsOptional()
  @IsString()
  customOptionName?: string;
}

export class EcomProductCombination {
  @IsDefined()
  @IsString()
  @IsNotEmpty()
  @Transform((obj) => obj?.toString())
  combinationID!: string;

  @IsDefined()
  @IsString()
  @IsNotEmpty()
  combinationHash!: string;

  @IsDefined()
  @IsString()
  @IsNotEmpty()
  combinationSKU!: string;

  @IsDefined()
  // @Transform(Number, { toClassOnly: true })
  @IsNumber()
  combinationSalesPrice!: number;

  @IsDefined()
  // @Transform(Number, { toClassOnly: true })
  @IsNumber()
  combinationOfferPrice!: number;

  @IsOptional()
  @Transform((obj) => Boolean(obj))
  @IsBoolean()
  isDefault?: boolean;

  @IsOptional()
  @ValidateNested({ each: true })
  @Type(() => EcomProductCombinationMedia)
  combinationMedia?: EcomProductCombinationMedia[];

  @IsOptional()
  customOptions?: EcomProductCustomOption[];

  @IsOptional()
  @Type(() => EcomCampaign)
  @ValidateNested({ each: true })
  campaign?: EcomCampaign[];

  @IsOptional()
  @IsNumber()
  stockCount?: number;

  @IsOptional()
  @IsString()
  videoUrl?: number;

  @IsOptional()
  @IsString()
  videoInteriorUrl?: number;
}
